import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "./Css/Subcategory.css";
import GameSidebar from "./GameSidebar";
const SubCateegorySection = () => {
  const location = useLocation();
  const [pathUrl, setPath] = useState();
  const path = window.location.pathname;
  useEffect(() => {}, [location]);

  return (
    <>
      {path.includes("/game/") && (
        <div>
          {/* <div className="subcategory-header">Subcategory</div> */}
          <div className="subcategory game-grid-1">
            <GameSidebar
              addclass="grid-raw"
              sidebarimg="grid-bar"
              position="center"
              limitgamefrom="4"
              limitgameto="100"
            />
          </div>
        </div>
      )}
    </>
  );
};
export default SubCateegorySection;
